import { useCallback, useState } from "react";
import { useInput, useNotify } from "react-admin";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import { uploadRazaSafai } from "./upload-raza-safai";
import RazaSafaiUploadControls from "./RazaSafaiUploadControls";

type RazaSafaiUploadFieldProps = {
  source?: string;
};

export default function RazaSafaiUploadField({ source = "safaiUrl" }: RazaSafaiUploadFieldProps) {
  const notify = useNotify();
  const [uploading, setUploading] = useState(false);
  const {
    field: { value, onChange },
  } = useInput({ source });

  const safaiUrl = typeof value === "string" && value.trim() ? value.trim() : null;

  const handleSelectFile = useCallback(
    async (file: File) => {
      setUploading(true);
      try {
        const image = await uploadRazaSafai(file);
        onChange(image);
        notify("Safai uploaded", { type: "success" });
      } catch (err: unknown) {
        const message =
          (err as { response?: { data?: { message?: string } } })?.response?.data?.message ??
          (err instanceof Error ? err.message : "Failed to upload safai");
        notify(message, { type: "error" });
      } finally {
        setUploading(false);
      }
    },
    [notify, onChange]
  );

  const handleClear = useCallback(() => {
    onChange(null);
  }, [onChange]);

  return (
    <Box sx={{ mb: 2 }}>
      <FormLabel component="legend" sx={{ mb: 1, typography: "body2" }}>
        Upload Safai
      </FormLabel>
      <RazaSafaiUploadControls
        safaiUrl={safaiUrl}
        uploading={uploading}
        onSelectFile={handleSelectFile}
        onClear={handleClear}
      />
    </Box>
  );
}
